const fragShader = `
precision mediump float;
uniform float iTime;
uniform float textureBrightness;
uniform float starBrightness;
uniform float starScale;
uniform float amplitudeCorrectionFactor;
uniform float offsetX;
uniform float offsetY;
uniform vec2 iResolution;
varying vec2 outTexCoord;
uniform sampler2D uMainSampler;

float cheap_star(vec2 uv, float anim, float scaleFactor)
{
    uv = abs(uv) * scaleFactor;
    vec2 pos = min(uv.xy/uv.yx, anim);
    float p = (2.0 - pos.x - pos.y);
    return (2.0 + p * (p * p - 1.5)) / (uv.x + uv.y);      
}

void main() {
    vec4 startColor = texture2D(uMainSampler, outTexCoord);
    vec2 uv = (outTexCoord * 2.0 - 1.0) * iResolution.y / iResolution.xy; // Смещение в центр

    // Поднятие центра анимации на 25% вверх
    uv.y += offsetY;
    uv.x += offsetX;

    uv *= 16.0 * (cos(iTime * 2.0) * starScale + amplitudeCorrectionFactor); // Масштаб
    float anim = sin(iTime * 12.0) * 0.01 + 1.0;
    float scaleFactor = 0.04;

    float darknessFactor = min(cheap_star(uv, anim, scaleFactor), 2.);

    gl_FragColor = vec4(darknessFactor * vec3(0.35 + starBrightness, 0.2 + starBrightness, 0.15 + starBrightness), startColor.a) * startColor * textureBrightness;
}
`;

export class GlowPipeline2 extends Phaser.Renderer.WebGL.Pipelines.MultiPipeline {
      constructor(
            game,
            textureBrightness = 0.9,
            starBrightness = 0.53,
            starScale = 0.5,
            amplitudeCorrectionFactor = -2.0,
            offsetX = 0.1,
            offsetY = -0.1
      ) {
            super({
                  game,
                  fragShader,
                  uniforms: [
                        'uProjectionMatrix',
                        'uMainSampler',
                        'iResolution',
                        'iTime'
                  ]
            });

            this.textureBrightness = textureBrightness;
            this.starBrightness = starBrightness;
            this.starScale =  starScale;
            this.amplitudeCorrectionFactor = amplitudeCorrectionFactor;
            this.offsetX = offsetX;
            this.offsetY = offsetY;
      }

      onPreRender() {
            this.set1f('iTime', this.game.loop.time / 1000);
            this.set1f('textureBrightness', this.textureBrightness);
            this.set1f('starBrightness', this.starBrightness);
            this.set1f('starScale', this.starScale);
            this.set1f('amplitudeCorrectionFactor', this.amplitudeCorrectionFactor);
            this.set1f('offsetX', this.offsetX);
            this.set1f('offsetY', this.offsetY);
            this.set2f('iResolution', this.renderer.width, this.renderer.height);
      }
}
